import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import HomeView from '@/views/HomeView.vue'
import ContactView from '@/views/ContactView.vue'
import RulesView from '@/views/RulesView.vue'
import RegisterView from '@/views/RegisterView.vue'
import SponsorsView from '@/views/SponsorsView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: HomeView
  },
  {
    path: '/Home',
    name: 'home',
    component: HomeView
  },
  {
    path: '/contact',
    name: 'contact',
    component: ContactView
  },
  {
    path: '/rules',
    name: 'rules',
    component: RulesView
  },
  {
    path: '/register',
    name: 'register',
    component: RegisterView
  },
  {
    path: '/sponsors',
    name: 'sponsors',
    component: SponsorsView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  // Admin routes
  {
    path: '/admin/login',
    name: 'admin-login',
    component: () => import(/* webpackChunkName: "admin" */ '../views/AdminLoginView.vue'),
    meta: { hideNavigation: true }
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import(/* webpackChunkName: "admin" */ '../views/AdminView.vue'),
    meta: { requiresAuth: true, hideNavigation: true }
  },
  // Auth callback route for password reset, email confirmation, etc.
  {
    path: '/auth/callback',
    name: 'auth-callback',
    component: () => import(/* webpackChunkName: "admin" */ '../views/AuthCallbackView.vue'),
    meta: { hideNavigation: true }
  }
]

const router = new VueRouter({
  routes
})

// Navigation guard for protected routes
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const isAuthenticated = store.getters.isAuthenticated

  if (requiresAuth && !isAuthenticated) {
    next('/admin/login')
  } else {
    next()
  }
})

export default router
